import { useCallback } from 'react';
import { useRouter } from '@funtech-int/rival-react';

import { MediaBillingFeature } from '@/shared/constants/billingFeatures';
import { useSearchParams } from '@/shared/hooks/useSearchParams';
import { showcaseRoute } from '@/scenarios/showcase/routes';
import { ShowcaseId } from '@/shared/lib/analytics/showcase';
import { removeQueryParamsFromUrl } from '@/shared/lib/navigation';

interface Props {
    billingFeatureNames?: string[];
}

export const useMultiOfferSuccessPurchase = ({ billingFeatureNames }: Props) => {
    const router = useRouter();
    const searchParams = useSearchParams();
    const paywallOfferTab = searchParams.get('paywallOfferTab');

    return useCallback(() => {
        if (billingFeatureNames?.includes(MediaBillingFeature.AMEDIATEKA)) {
            router.navigate({ to: showcaseRoute({ id: ShowcaseId.AMEDIATEKA }) });
        } else if (paywallOfferTab) {
            removeQueryParamsFromUrl({ router, queryParams: ['paywallOfferTab'] });
        }
    }, [billingFeatureNames, router, paywallOfferTab]);
};
